var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorsIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.582,
    height: 25.083,
    viewBox: "0 0 21.582 25.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_424",
    x: 0,
    y: 0,
    width: 21.582,
    height: 25.083,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trac\\xE9_424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_424-2",
    "data-name": "Trac\\xE9 424",
    d: "M1783.866,496.274c-.154-.147-.271-.25-.378-.362a1,1,0,1,1,1.409-1.419c.113.108.218.224.335.345.052-.048.095-.085.135-.125.6-.6,1.192-1.206,1.8-1.8a2.084,2.084,0,0,1,3.448.883,2.019,2.019,0,0,1-.523,2.1c-.618.633-1.252,1.252-1.916,1.915.134.118.272.221.387.346a.993.993,0,0,1-.509,1.663.941.941,0,0,1-.9-.248c-.121-.114-.226-.245-.357-.388-.13.135-.232.244-.337.35q-.405.408-.813.813c-.2.2-.4.23-.548.083s-.125-.35.073-.548l1.02-1.018c.038-.038.073-.077.1-.1l-2.019-2.02c-.016.015-.054.05-.091.086-1.427,1.428-2.85,2.86-4.284,4.281a1.617,1.617,0,0,0-.482,1.442c.016.128.018.258.024.388a.855.855,0,0,1-.27.669c-.107.107-.216.212-.318.323a.162.162,0,0,0,0,.245.17.17,0,0,0,.247.005.791.791,0,0,0,.127-.125,1.241,1.241,0,0,1,1.285-.445,2.2,2.2,0,0,0,.673-.032,1.337,1.337,0,0,0,.712-.422q1.063-1.066,2.133-2.126a.592.592,0,0,1,.273-.147.274.274,0,0,1,.305.164.315.315,0,0,1-.023.351.981.981,0,0,1-.109.119c-.706.706-1.416,1.408-2.118,2.118a2.144,2.144,0,0,1-1.775.648.544.544,0,0,1-.1-.007.818.818,0,0,0-.882.333.819.819,0,0,1-1.162.093.835.835,0,0,1-.1-1.2,2.994,2.994,0,0,1,.307-.311.426.426,0,0,0,.132-.391,5.87,5.87,0,0,1,0-.95,1.964,1.964,0,0,1,.621-1.178q2.145-2.138,4.285-4.28A1.336,1.336,0,0,1,1783.866,496.274Z",
    transform: "translate(-1773.63 -492.33)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorsIcons);
export default __webpack_public_path__ + "static/media/colors-icons.2f66c80be42f899566aaad31478e7e11.svg";
export { ForwardRef as ReactComponent };